<template>
  <div class="map-menu__container">
    <div
      v-if="props___.onlyBars"
    >
      <i
        class="map-menu__icon map-menu__icon--white pi pi-bars"
        @click="emit('toggle-sidebar')"
      ></i>
    </div>
    <div
      v-if="!props___.onlyBars"
      :class="menuClasses"
    >
      <div :class="menuClasses">
        <MapMenuItem
          v-for="m in menuHierarchy$$"
          :key="m.id"
          :menu-hierarchy-item="m"
          :sidebar="props___.sidebar"
          :printing="printing"
          @click-item="(item) => clickItem(item)"
        />
      </div>
      <div
        class="map-menu__info"
        :class="{'map-menu__info--sidebar': props___.sidebar}"
      >
        <!-- {{ props___.onlyBars }} -->
        <span>NIPO: 196-24-065-5</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useRouter} from 'vue-router';
import {menuHierarchy$$} from '@/pages/_root/routes/menu.routes';
import MapMenuItem from './MapMenuItem';
// import {toStringHDMS} from 'ol/coordinate';
import {transform} from 'ol/proj';
import {useStore} from 'vuex';
// Store
const store = useStore();
const router = useRouter();

// #region Props, Emits
const props___ = defineProps({
  sidebar: {
    type: Boolean,
    default: false,
  },
  onlyBars: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['toggle-sidebar', 'click-item']);
// #endregion

// #region Params, Ref, Reactives, Computed
const mapCenter = computed(() => store.state.map.center);
const printing = computed(() => store.state.app.printing);
const menuClasses = computed(() => {
  const baseClasses = 'menu__container flex flex-1 gap-1';
  if (props___.sidebar) {
    return baseClasses + ' flex-column p-2';
  }
  return baseClasses;
});
// #endregion

// #region Functions
async function clickItem(item) {
  // Minimify
  await store.dispatch('app/setOverlayMinification', true);
  if (!!item?.route) {
    await router.push(item.route);
  }
  const parsedCoordinates = parseCoordinates([mapCenter.value[0], mapCenter.value[1]]);
  switch (item.id) {
    case 'maps':
      const url = 'https://www.google.com/maps?ll=' +
        parsedCoordinates +
        '&z=' + store.state.map.zoom +
        '&q=' + parsedCoordinates;
      window.open(url);
      console.log('URL:', url);
      break;
    case 'earth':
      const urlEarth = 'https://earth.google.com/web/@' +
        parsedCoordinates +
       ',' + zoomToAltitudeFormula(store.state.map.zoom) + 'd' + ',0a';
      console.log('URL:', urlEarth);
      window.open(urlEarth);
      break;
    case 'print':
      await store.dispatch('map/printMap', {}, {root: true});
      break;
    default:
      if (!item?.children?.length) {
        console.log('Action not found.');
      }
      break;
  }
  if (item.id.startsWith('font-size:')) {
    const [, command] = item.id.split(':');
    switch (command) {
      case 'default':
        await store.dispatch('app/setDefaultFontSizeVariation', {}, {root: true});
        break;
      case 'increase':
        await store.dispatch('app/increaseFontSizeVariation', {}, {root: true});
        break;
      case 'decrease':
        await store.dispatch('app/decreaseFontSizeVariation', {}, {root: true});
        break;
      default:
        break;
    }
  }
  if (item.id.startsWith('scale:')) {
    const meters = item?.data?.scale;
    if (!!meters) {
      await store.dispatch('map/setScale', {meters}, {root: true});
    }
  }
  if (item.id.startsWith('zoom-region-')) {
    const extent = item?.data?.extent;
    if (!!extent?.length) {
      await store.dispatch('map/setMapExtent', {extent}, {root: true});
    }
  }
  if (item?.reload) {
    router.go(0); // Reload page
    return;
  }
  emit('click-item');
}

function parseCoordinates(coordinates) {
  const coord4326 = transform(coordinates, 'EPSG:3857', 'EPSG:4326');
  const res = // swap coordinate lon and lat and assign to a Coordinate instance
    coord4326[1].toFixed(6) + ',' + coord4326[0].toFixed(6);
  return res;
}

// No es exacto en Google Earth pero se aproxima.
function zoomToAltitudeFormula(zoomLevel) {
  // Altitud máxima para el nivel de zoom 0
  const maxAltitude = 20000000; // Altitud aproximada para el nivel de zoom 0
  // Calcula la altitud dividiendo por 2 por cada nivel de zoom
  const altitude = maxAltitude / Math.pow(2, zoomLevel);
  return altitude * 1000; // Convertir a metros
}


// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
// #endregion
</script>

<style lang="scss" scoped>
.map-menu {
  &__container {
    flex: 1;
    display:flex;
  }

  &__icon {
    padding: (0.1 * $brand__boxspace--headerheight) $brand__boxspace--medium;
    font-size: $brand__boxspace--headerheight * 0.6;
    cursor: pointer;
    &--white {
      color: white;
    }
  }

  &__info {
    justify-self: flex-end;
    align-self: center;
    color: #fff;
    margin-right: 10px;
    font-size: 0.7rem;
    font-family: 'Arial', sans-serif;

    &--sidebar {
      // background-color: $brand__color--blue;
      color: $brand__color--blue;
      // color: $brand__color--white;
      align-self: flex-end;
      font-size: 0.8rem;
      // width: 100%;
      flex: 1;
      padding: 3px 5px;
    }
  }
}
</style>
